import FallbackVisitor from "../FallbackVisitor.js";
const ExclusiveMinimumVisitor = FallbackVisitor;
export default ExclusiveMinimumVisitor;